import { render, staticRenderFns } from "./SpaceManage.vue?vue&type=template&id=a1445da2&"
import script from "./SpaceManage.vue?vue&type=script&lang=ts&"
export * from "./SpaceManage.vue?vue&type=script&lang=ts&"
import style0 from "./SpaceManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports